import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'shards-react';
import useUserRoles from '../../../../hooks/useUserRoles';
import { RootState, useDispatch, useSelector } from '../../../../redux/store';
import { hideRoleAttention } from '../../../../redux/slices/session';
import getRole from '../../../../utils/getRole';
import type { Role } from '../../../../types/common';

const RoleAlert = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isMaintenanceadmin, isAdminOrPoweruser } = useUserRoles();
  const { roles, displayRoleAttention } = useSelector((state: RootState) => state.session);
  const role: Role = getRole(roles);
  const text: string = t('now') + ' ' + role + ' ' + t('isRole');

  // SIDE EFFECT
  // ================================================================================

  // 確認用

  // EVENT HANDLER
  // ================================================================================

  const dismiss = (): void => {
    dispatch(hideRoleAttention());
  };

  // VIEW
  // ================================================================================

  return (isMaintenanceadmin || isAdminOrPoweruser) && displayRoleAttention ? (
    <Alert dismissible={dismiss} theme="warning" className="text-center">
      {text}
    </Alert>
  ) : (
    <></>
  );
};
export default RoleAlert;
